import * as MenuActions from './menu.action';

export interface MenuState {
  activeMenu: string;
  searchBarStatus: boolean;
  filterStatus: boolean;
}

const initialState: MenuState = {
  activeMenu: 'menu',
  searchBarStatus: false,
  filterStatus: false,
};

export function menuReducer(
  state = initialState,
  action: MenuActions.MenuActions
  ) {

  switch (action.type) {

    case MenuActions.OPEN_SEARCH_BAR:
      return {
        ...state,
        activeMenu: 'search',
        searchBarStatus: true,
        filterStatus: false
      };

    case MenuActions.CLOSE_SEARCH_BAR:
      return {
        ...state,
        activeMenu: 'menu',
        searchBarStatus: false,
        filterStatus: false
      };

    case MenuActions.OPEN_FILTER_BAR:
      return {
        ...state,
        activeMenu: 'filter',
        searchBarStatus: false,
        filterStatus: true
      };

    case MenuActions.CLOSE_FILTER_BAR:
      return {
        ...state,
        activeMenu: 'menu',
        searchBarStatus: false,
        filterStatus: false
      };

    case MenuActions.CHANGE_MENU_ACTIVE:
      const menu = action.payload.activeMenu;
      return {
        ...state,
        activeMenu: menu
      };

    case MenuActions.CHANGE_DISPENSARY:
      const disp_id = action.payload.disp_id;
      return {
        ...state,
        disp_id: disp_id
      };

    case MenuActions.OPEN_SIGN_IN:
      return {
        ...state,
      };
    default:
      return state;
  }
}
